import { render, staticRenderFns } from "./PromotionManage.vue?vue&type=template&id=f70aa06a&scoped=true"
import script from "./PromotionManage.vue?vue&type=script&lang=js"
export * from "./PromotionManage.vue?vue&type=script&lang=js"
import style0 from "./PromotionManage.vue?vue&type=style&index=0&id=f70aa06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70aa06a",
  null
  
)

export default component.exports